import RichDataSource from "@/models/Accounts/Shared/Transactions/RichDataSource";

export default (richDataSource: RichDataSource) => {
    let returnVal = "Undefined";
    switch (richDataSource) {
        case RichDataSource.SaaScada: {
            returnVal = "SaaScada"
            break;
        }
        case RichDataSource.ClearBank: {
            returnVal = "ClearBank"
            break;
        }
        case RichDataSource.GPS: {
            returnVal = "GPS (Thredd)"
            break;
        }
        case RichDataSource.Swisscom: {
            returnVal = "Swisscom"
            break;
        }
    }
    return returnVal;
}